import { EnumTipoAlteracao } from "../enums/EnumTipoAlteracao";

export class Versao {
  prefixo: string;
  texto: string;
  textoMarcado: string;
  textoGrifado: string;
  observacoes: string;
  revogado: boolean;
  tipoUltimaAlteracao: EnumTipoAlteracao;
}
